import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { PessoaTermoLGPDStatusPipeModule } from '../pipes';

import { PessoaTermoLGPDStatusBadgeComponent } from './pessoa-termo-lgpd-status-badge.component';


@NgModule({
    imports: [
        SharedModule,
        PessoaTermoLGPDStatusPipeModule
    ],
    declarations: [
        PessoaTermoLGPDStatusBadgeComponent
    ],
    exports: [
        PessoaTermoLGPDStatusBadgeComponent
    ]
})
export class PessoaTermoLGPDStatusBadgeModule { }
